import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  private isOnline: boolean = true;
  private alert: HTMLIonAlertElement | null = null;

  constructor(private alertController: AlertController) {
    this.checkInternetConnection();
    this.showSplashScreen();
  }

  ngOnInit() {
    window.addEventListener('online', () => this.checkInternetConnection());
    window.addEventListener('offline', () => this.checkInternetConnection());
  }

  // Show the splash for two seconds and then automatically hide it:
  async showSplashScreen() {
    await SplashScreen.show({
      showDuration: 2000,
      autoHide: true,
    });
  }

  private async checkInternetConnection() {
    this.isOnline = navigator.onLine;
    if (!this.isOnline) {
      await this.presentAlert();
    } else if (this.alert) {
      await this.alert.dismiss();
      this.alert = null;
    }
  }

  private async presentAlert() {
    this.alert = await this.alertController.create({
      header: 'Sin conexión a Internet',
      message: 'No hay conexión a internet. La aplicación requiere una conexión activa para funcionar.',
      backdropDismiss: false,
      cssClass: 'custom-alert',
      buttons: [
        {
          text: 'Reintentar',
          handler: () => {
            this.checkInternetConnection();
          }
        }
      ]
    });

    await this.alert.present();
  }
}
